import React, { CSSProperties, ReactNode } from 'react';
import cls from 'classnames';
import { clsPrefix } from './const';

import './base.scss';

interface CnStatisticCardProProps {
  /**
   * 容器className
   */
  className?: string;
  /**
   * 样式属性
   */
  style?: CSSProperties;

  /**
   * 子节点
   */
  children: ReactNode;

  /**
   * 是否隐藏边框
   */
  hideBorder?: boolean;
  /**
   * 点击事件
   */
  onClick?: () => void;

  /**
   * 是否选中状态
   */
  active?: boolean;

  /**
   *
   */
  canClick?: boolean;
}

/**
 * 指标卡 组件
 * @param {*} props
 * @returns
 */
function CnStatisticCardProBase({
  children,
  style,
  hideBorder,
  onClick,
  active,
  canClick,
}: CnStatisticCardProProps) {
  return (
    <div
      className={cls(clsPrefix, {
        [`${clsPrefix}-hide-border`]: hideBorder,
        active,
        [`${clsPrefix}-click`]: canClick,
      })}
      style={style}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
export { CnStatisticCardProBase };
export type { CnStatisticCardProProps };
